import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiUrls } from './ApiUrls';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class MomMinutesOfMeetingService {
  
  constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) { }
  
  deleteMeetingType(id: number) {
    return this.httpClient.delete(
      ApiUrls.deleteMomMeetingTypeUrl.replace('{id}', id.toString()));
  }

  saveMeetingType(body: { meetingType: any; }) {
    return this.httpClient.post(ApiUrls.saveMomMeetingTypeUrl, body);
  }

  getMeetingTypes() {
    return this.httpClient.get<any>(ApiUrls.getMomMeetingTypesUrl);
  }

  getMeetingTypeById(id: number) {
    return this.httpClient.get<any>(
      ApiUrls.getMomMeetingTypeUrl.replace('{id}', id.toString()));
  }

  updateMeetingType(body: any) {
    return this.httpClient.put(ApiUrls.updateMomMeetingTypeUrl, body);
  }

  getLotteriesByBoard(id: number) {
    return this.httpClient.get<any>(ApiUrls.getLotteriesByBoardUrl.replace('{id}', id.toString()));
  }

  getArchieveMeeting() {
    return this.httpClient.get<any>(ApiUrls.getArchieveMeetingUrl);
  }

  getMeetingsByUserId() {
    return this.httpClient.get<any>(ApiUrls.getMeetingsByUserIdUrl);
  }
  
  getBoards() {
    return this.httpClient.get<any>(ApiUrls.getMomBoardsUrl);
  }

  getMeetings() {
    return this.httpClient.get<any>(ApiUrls.getMeetingsUrl);
  }

  getMeetingsById(id: number) {
    return this.httpClient.get<any>(ApiUrls.getMeetingsByIdUrl.replace('{id}', id.toString()));
  }

  getLotteries() {
    return this.httpClient.get<any>(ApiUrls.getMomLotteriesUrl);
  }

  saveMeeting(body: any) {
    return this.httpClient.post<any>(ApiUrls.saveMomMeetingsUrl, body);
  }
  
  mediaFileUpload(fileData: FormData) {
    return this.httpClient.post<any>(ApiUrls.momMediaUploadUrl, fileData);
  }

  updateMeeting(res: any) {
    return this.httpClient.put<any>(ApiUrls.updateMomMeetingsUrl, res);
  }

  htmlToPdf(body: any) {
    return this.httpClient.post<any>(ApiUrls.momHtmlToPdfUrl, body);
  }

  updateRecordMeeting(value: any) {
    return this.httpClient.put<any>(ApiUrls.updateRecordMeetingUrl, value);
  }

  meetingApprovedWithPDF(body: { meeting: any; htmlContent: string; }) {
    return this.httpClient.put<any>(ApiUrls.meetingApprovedWithPDFUrl, body);
  }

  updateCorrectionMeeting(meetingId: number, notes: string) {
    return this.httpClient.put<any>(ApiUrls.updateCorrectionMeetingUrl.replace('{meetingId}', meetingId.toString()), notes);
  }

  getMeetingsByStatus(status: string) {
    return this.httpClient.get<any>(ApiUrls.getMeetingsByStatusUrl.replace('{status}', status));
  }

  getMomUserByEmail(email: string) {
    return this.httpClient.get<any>(ApiUrls.getMomUserByEmailIdUrl.replace('{email}', email));
  }

  downloadFile(url:string, fielName:string, ): void {
    this.httpClient.get(url, { responseType: 'arraybuffer' })
      .subscribe((data: ArrayBuffer) => {
        const blob = new Blob([data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fielName;
        link.click();
      });
  }

  getApproverMeetingsByUserId() {
    return this.httpClient.get<any>(ApiUrls.getApproverMeetingsByUserIdUrl);
  }

  async successToast(msg) {
    await this._snackBar.open(
      msg,
      "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      }
    );
  }
}
